import { MyVehiclesPanel } from "@/components/organisms";
import { KyvValidationsPanel } from "@/components/organisms/Vehicles/MyVehicles/KyvValidationsPanel";
import { AddVehicle } from "./subpages/AddVehicle";
import { EditVehicle } from "./subpages/EditVehicle";
import { ViewVehicle } from "./subpages/ViewVehicle";

export const MyVehicles = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col pb-2">
      {/* Verifications live only in Veivo until they pass, so without this an
          in-flight or rejected onboarding would be invisible here. */}
      <KyvValidationsPanel />
      <MyVehiclesPanel />
    </div>
  );
};

MyVehicles.AddVehicle = AddVehicle;
MyVehicles.EditVehicle = EditVehicle;
MyVehicles.ViewVehicle = ViewVehicle;
